// @flow

import * as React from 'react';

import { selectFromConfig } from '@gandi/redux-config';
import { useTranslator } from '@gandi/translate';

import {
  Alert,
  Base,
  OrderedList,
  TypoListItem,
  TypoListTitle,
  TypoListHelp,
} from '@gandi/ui';
import { ListItem, ListRow, TitleCell } from '@gandi/ui/deprecated';

import { useAppSelector } from 'src/hooks/useAppSelector';

export type ReferAFriendWelcomeBoxProps = {
  affiliate?: string,
};

function ReferAFriendWelcomeBox(
  props: ReferAFriendWelcomeBoxProps,
): React.MixedElement | null {
  const { __, formatPrice } = useTranslator();

  const canShowRaf = useAppSelector(
    selectFromConfig<boolean>('flags.SHOW_REFER_A_FRIEND', false),
  );

  if (props.affiliate !== 'FRIEND') {
    return null;
  }

  return (
    <Base marginBottom="base">
      {canShowRaf ? (
        <>
          <ListRow separatorBottom>
            <ListItem>
              <TitleCell icon="gift" iconTheme="green">
                {__('Welcome to Gandi!')}
              </TitleCell>
            </ListItem>
          </ListRow>
          <Base padding="small" backgroundColor="surface">
            <Base tagName="p" marginTop="none">
              {__('A friend has recommended Gandi to you. Welcome, and enjoy!')}
            </Base>
            <OrderedList>
              <TypoListItem>
                <TypoListTitle size="base">
                  {__(
                    'Thanks to your friend, you get a 20%% discount on a domain name (usable for either a domain name registration or transfer) and a 75%% discount on a 6-month Simple Hosting S+ web hosting plan!',
                  )}
                </TypoListTitle>
              </TypoListItem>
              <TypoListItem>
                <TypoListTitle size="base">
                  {__(
                    'Refer a friend in turn, and receive a %(reward)s (or equivalent value in your currency) promo code.',
                    {
                      // $FlowFixMe[incompatible-call]
                      reward: formatPrice('5', 'EUR'),
                    },
                  )}
                </TypoListTitle>
                <TypoListHelp color="light">
                  {__(
                    'It works every time someone new completes a first %(threshold)s order at Gandi from your referral link.',
                    {
                      // $FlowFixMe[incompatible-call]
                      threshold: formatPrice('3', 'EUR'),
                    },
                  )}
                </TypoListHelp>
              </TypoListItem>
            </OrderedList>
          </Base>
        </>
      ) : (
        <Alert
          intent="warning"
          message={__(
            'Thank you for your loyalty. The Refer a Friend program is currently undergoing maintenance and will be back very soon.',
          )}
          title={__('Warning')}
        />
      )}
    </Base>
  );
}

export default (React.memo<ReferAFriendWelcomeBoxProps>(
  ReferAFriendWelcomeBox,
): React.ComponentType<ReferAFriendWelcomeBoxProps>);
